var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: { title: "Compress", centered: "" },
      on: { hide: _vm.closeHandler },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "ButtonOutline",
                {
                  attrs: { variant: "outline-primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.modal.hide()
                    },
                  },
                },
                [_vm._v("\n      Cancel\n    ")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [_vm._v(" "), _c("b-spinner")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }